import API from "./API";
import axios from "axios";

export default class ImportTemplateAPI extends API {
  constructor(parameters = {}) {
    super("/ImportTemplate", parameters);
  }

  generate(template) {
    return this.export('post', `${this.endpoint}/Generate?templateName=${template}`);
  }

  getLastLogs() {
    return this.submit('get', `/api/Log/GetLast`);
  }
}
